export default __webpack_public_path__ + "static/media/18.7884d161.jpg";